var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "el-col",
        [
          _c(
            "el-form",
            {
              ref: "suspensionForm",
              attrs: {
                model: _vm.suspensionForm,
                "label-width": "80px",
                size: "mini",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("show"),
                      expression: "showProperty('show')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.show") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeSuspensionAttr("show")
                        },
                      },
                      model: {
                        value: _vm.suspensionForm.show,
                        callback: function ($$v) {
                          _vm.$set(_vm.suspensionForm, "show", $$v)
                        },
                        expression: "suspensionForm.show",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.show")) + "\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }